const compactFormatter = new Intl.NumberFormat('en', {
  notation: 'compact',
  maximumFractionDigits: 1,
});

/** Compact human-readable number (e.g. 12400 → "12.4K"). */
export function formatCompactNumber(n: number): string {
  if (!Number.isFinite(n)) return '0';
  return compactFormatter.format(n);
}
